(function () {
  // mobile menu
  var burger = document.querySelector('[data-burger]');
  var nav = document.querySelector('[data-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // roast filter chips
  document.querySelectorAll('[data-filter-root]').forEach(function (root) {
    var chips = root.querySelectorAll('[data-filter]');
    var items = root.querySelectorAll('[data-roast]');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var f = chip.getAttribute('data-filter');
        chips.forEach(function (c) { c.classList.toggle('is-on', c === chip); });
        items.forEach(function (it) {
          it.hidden = !(f === 'all' || it.getAttribute('data-roast') === f);
        });
      });
    });
  });

  // product gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        main.src = b.getAttribute('data-src');
        g.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
      });
    });
  });

  // quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v += parseInt(b.getAttribute('data-step'), 10);
        input.value = Math.max(1, v);
      });
    });
  });

  // mood quiz
  document.querySelectorAll('[data-quiz]').forEach(function (root) {
    var data = JSON.parse(root.querySelector('[data-quiz-data]').textContent);
    var state = { roast: null, flavor: null };
    var qs = root.querySelectorAll('[data-q]');
    var result = root.querySelector('[data-result]');
    var step = root.querySelector('[data-step-label]');
    function show(i) {
      qs.forEach(function (q, idx) { q.hidden = idx !== i; });
      result.hidden = true;
      if (step) step.textContent = data.labels.question.replace('{n}', i + 1).replace('{total}', qs.length);
    }
    function finish() {
      var key = state.roast + '|' + state.flavor;
      var r = data.results[key] || data.results[state.roast + '|any'] || data.results['*'] || null;
      qs.forEach(function (q) { q.hidden = true; });
      if (!r) return;
      result.hidden = false;
      if (step) step.textContent = data.labels.result;
      result.querySelector('[data-r-mood]').textContent = r.mood;
      result.querySelector('[data-r-title]').textContent = r.title;
      result.querySelector('[data-r-note]').textContent = r.note;
      var a = result.querySelector('[data-r-link]');
      a.href = r.url;
      var img = result.querySelector('[data-r-img]');
      if (r.image) { img.src = r.image; img.hidden = false; } else { img.hidden = true; }
    }
    root.querySelectorAll('[data-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-pick-key');
        state[k] = b.getAttribute('data-pick');
        var qi = parseInt(b.closest('[data-q]').getAttribute('data-q'), 10);
        if (k === 'roast' && state.roast === data.skip_roast) { state.flavor = 'any'; finish(); return; }
        if (qi + 1 >= qs.length) finish(); else show(qi + 1);
      });
    });
    var again = root.querySelector('[data-restart]');
    if (again) again.addEventListener('click', function () { state = { roast: null, flavor: null }; show(0); });
    show(0);
  });
})();
